// ZZYON LEX — utilidades de formatação locais (não dependem de torre-shared).

export const fmtBRL = (v) =>
  v == null
    ? '—'
    : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(v));

export const fmtDate = (iso) => {
  if (!iso) return '—';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('pt-BR');
};

export const fmtDateTime = (iso) => {
  if (!iso) return '—';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
};

export const fromNow = (iso) => {
  if (!iso) return '—';
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60_000) return 'agora há pouco';
  if (ms < 3_600_000) return `há ${Math.round(ms / 60_000)} min`;
  if (ms < 86_400_000) return `há ${Math.round(ms / 3_600_000)} h`;
  const d = Math.round(ms / 86_400_000);
  if (d < 30) return `há ${d} dia${d === 1 ? '' : 's'}`;
  return fmtDate(iso);
};

export const escapeHtml = (s) =>
  String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

export const severidadeBadge = (sev) => {
  const map = {
    info:     { cls: 'lex-badge lex-badge-info', txt: 'INFO' },
    warning:  { cls: 'lex-badge lex-badge-warn', txt: 'ATENÇÃO' },
    critical: { cls: 'lex-badge lex-badge-crit', txt: 'CRÍTICO' },
  };
  return map[sev] || map.info;
};

export const riscoBadge = (risco) => {
  const map = {
    provavel: { cls: 'lex-badge lex-badge-crit', txt: 'PROVÁVEL' },
    possivel: { cls: 'lex-badge lex-badge-warn', txt: 'POSSÍVEL' },
    remoto:   { cls: 'lex-badge lex-badge-ok',   txt: 'REMOTO' },
  };
  return map[risco] || { cls: 'lex-badge lex-badge-info', txt: 'SEM CLASSIFICAÇÃO' };
};

export const criticidadeBadge = (c) => {
  const map = {
    vencida:  { cls: 'lex-badge lex-badge-crit', txt: 'VENCIDA' },
    critica:  { cls: 'lex-badge lex-badge-crit', txt: 'CRÍTICA' },
    urgente:  { cls: 'lex-badge lex-badge-warn', txt: 'URGENTE' },
    atencao:  { cls: 'lex-badge lex-badge-bronze', txt: 'ATENÇÃO' },
    ok:       { cls: 'lex-badge lex-badge-ok',  txt: 'OK' },
  };
  return map[c] || map.ok;
};

// Markdown muito básico → HTML (h1-h3, **bold**, *italic*, lista, code inline)
export function mdToHtml(md = '') {
  if (!md) return '';
  let s = escapeHtml(md);
  // headers
  s = s.replace(/^### (.+)$/gm, '<h3>$1</h3>');
  s = s.replace(/^## (.+)$/gm,  '<h2>$1</h2>');
  s = s.replace(/^# (.+)$/gm,   '<h1>$1</h1>');
  // bold/italic/code
  s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  s = s.replace(/\*([^*]+)\*/g, '<em>$1</em>');
  s = s.replace(/`([^`]+)`/g, '<code>$1</code>');
  // listas simples
  s = s.replace(/^(?:- |\* )(.+)$/gm, '<li>$1</li>');
  s = s.replace(/(<li>[\s\S]+?<\/li>(?:\n<li>[\s\S]+?<\/li>)*)/g, '<ul>$1</ul>');
  // parágrafos
  s = s.replace(/\n{2,}/g, '</p><p>');
  return `<p>${s}</p>`;
}
